
import React from "react";

type Props = {
  fromTop: number;
  fromLeft: number;
  toTop: number;
  toLeft: number;
  type: string;
  rowHeight: number;
}

const GanttChartBodyArrow = (props: Props) => {

  const goesUp = props.fromTop > props.toTop
  const goesLeft = props.fromLeft > props.toLeft
  const goesRight = props.fromLeft < props.toLeft

  const { type } = props

  let startX
  let startY
  let endX
  let endY

  let path = ``

  let x
  let y

  if (!goesUp) {

    startY = props.fromTop + 26

    if (type === 'diamond_to_diamond') {

      startX = props.fromLeft + 16.5
      endX = props.toLeft + 16.5
      endY = props.toTop + 4.5
    } else if (type === 'diamond_to_start') {

      startX = props.fromLeft + 17
      endX = props.toLeft + 12
      endY = props.toTop + 5
    } else if (type === 'start_to_diamond') {

      startX = props.fromLeft + 12
      endX = props.toLeft + 16.5
      endY = props.toTop + 4.5
    } else if (type === 'end_to_diamond') {

      startX = props.fromLeft - 10
      endX = props.toLeft + 16.5
      endY = props.toTop + 4.5
    } else if (type === 'start_to_start') {

      startX = props.fromLeft + 10
      endX = props.toLeft + 10
      endY = props.toTop + 5
    } else {

      startX = props.fromLeft - 12
      endX = props.toLeft + 12
      endY = props.toTop + 5
    }

    x = startX
    y = startY

    path += `M ${x},${y}`

    if (goesLeft) {

      // dobla a la izquierda
      x -= 3
      y += 3
      path += ` a 3 3 0 0 1 -3 3`

      // retrocede hasta el destino
      x = props.toLeft + 20
      if (type === 'start_to_start' || type === 'end_to_start') {
        x = props.toLeft + 15
      }
      path += ` L ${x},${y}`

      // dobla hacia abajo
      x -= 3
      y += 3
      path += ` a 3 3 0 0 0 -3 3`
    } else if (goesRight) {

      // dobla hacia la derecha
      x += 3
      y += 3
      path += ` a 3 3 0 0 0 3 3`

      x = endX - 3.5
      path += ` L ${x},${y}`

      // dobla hacia abajo
      x += 3
      path += ` a 3 3 0 0 1 3 3`
    }

    // baja hasta el destino
    path += ` L ${endX},${endY}`

    // dibuja la flecha hacia abajo
    path += ` M ${endX - 4},${endY - 5} L ${endX},${endY}`
    path += ` M ${endX + 4},${endY - 5} L ${endX},${endY}`
  } else {

    startY = props.fromTop + 5

    if (type === 'diamond_to_diamond') {

      startX = props.fromLeft + 16.5
      endX = props.toLeft + 16.5
      endY = props.toTop + 26.5
    } else if (type === 'diamond_to_start') {

      startX = props.fromLeft + 17
      endX = props.toLeft + 16
      endY = props.toTop + 26
    } else if (type === 'start_to_diamond') {

      startX = props.fromLeft + 16
      endX = props.toLeft + 16.5
      endY = props.toTop + 26.5
    } else if (type === 'end_to_diamond') {

      startX = props.fromLeft - 10
      endX = props.toLeft + 16.5
      endY = props.toTop + 26.5
    } else if (type === 'start_to_start') {

      startX = props.fromLeft + 16
      endX = props.toLeft + 16
      endY = props.toTop + 26
    } else {

      startX = props.fromLeft - 12
      endX = props.toLeft + 16
      endY = props.toTop + 26
    }

    x = startX
    y = startY

    path += `M ${x},${y}`

    if (goesLeft) {

      // dobla a la izquierda
      x -= 3
      y -= 3
      path += ` a 3 3 0 0 0 -3 -3`

      // retrocede hasta el destino
      x = props.toLeft + 19
      path += ` L ${x},${y}`

      // dobla hacia arriba
      x -= 3
      y -= 3
      path += ` a 3 3 0 0 1 -3 -3`
    } else if (goesRight) {
      // dobla hacia la derecha
      x += 3
      y -= 3
      path += ` a 3 3 0 0 1 3 -3`

      // va hacia la altura del destino
      x = endX - 3
      path += ` L ${x},${y}`

      // dobla hacia arriba
      path += ` a 3 3 0 0 0 3 -3`

      x += 3
      y -= 3
      path += ` L ${x},${y}`
    }

    // sube hacia el destino
    path += ` L ${endX},${endY}`

    // dibuja la flecha hacia arriba
    path += ` M ${endX - 4},${endY + 5} L ${endX},${endY}`
    path += ` M ${endX + 4},${endY + 5} L ${endX},${endY}`
  }

  return (
    <path
      className="gantt-arrow"
      d={path}
    />
  )
}

export default GanttChartBodyArrow
